import * as React from 'react';
import styled from 'styled-components';
import IImage from '../../Entities/Image';

interface Props extends IImage {
  maxWidth?: string;
  fixed?: boolean;
  scrollValue?: number;
  getRef?: (element: HTMLElement) => void;
}

const Image = styled.img`
  max-width: ${(props: Props) => props.maxWidth || '100%'};
  ${(props: Props) => (props.fixed ? 'min-height: 200px' : '')};
  ${(props: Props) => (props.fixed ? 'max-height: 75vh' : '')};
  ${(props: Props) => (props.fixed ? 'height: 100vw' : '')};
  ${(props: Props) => (props.fixed ? 'width: 100%' : '')};
  ${(props: Props) => (props.fixed ? 'object-fit: cover' : '')};
  ${(props: Props) => (props.fixed ? 'position: fixed' : '')};
  ${(props: Props) => (props.fixed ? 'top: 0' : '')};
  ${(props: Props) => (props.fixed ? 'right: 0' : '')};
  ${(props: Props) => (props.fixed ? 'left: 0' : '')};
  ${(props: Props) => (props.fixed ? 'z-index: -1' : '')};
`;

const transform = (props: Props) =>
  props.fixed && props.scrollValue ? { transform: `translateY(${props.scrollValue}px)` } : {};

export default (props: Props) => (
  <Image
    innerRef={props.getRef}
    srcSet={props.srcSet}
    sizes={props.sizes}
    src={props.src}
    alt={props.alt}
    style={transform(props)}
    {...props}
  />
);



// WEBPACK FOOTER //
// ./src/components/Image/Image.tsx